import apiFetch from '../../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `ControlMorfologico/eliminarControlMorfologicoSeleccion`, method: 'POST', body: {list}, token: token})
}